import TableFilter from '../table-models/TableFilter';

export const defaultBadgesFilters: TableFilter[] = [
    { field: 'targetName', label: 'Title', value: '' },
    //{ field: 'hideCanceled', label: 'Hide Inactive', value: true },
];
